export class Login {
    ID: number;
    UserTypeId: number;
    CompanyId: number;
    UnitId: number;
}